export enum OrderMode {
    ASC,
    DESC,
}

export default interface GlossOrdering {
    createdAt?: OrderMode;
    name?: OrderMode;
}
